const CONSENT_KEY = 'tiiny_cookie_consent'
const CONSENT_VERSION = '1.0'

export const CONSENT_TYPES = {
  NECESSARY: 'necessary',
  ANALYTICS: 'analytics',
  MARKETING: 'marketing',
  PREFERENCES: 'preferences'
}

export const getStoredConsent = () => {
  try {
    const stored = localStorage.getItem(CONSENT_KEY)
    if (stored) {
      return JSON.parse(stored)
    }
  } catch (error) {
    console.error('Error reading cookie consent from localStorage:', error)
  }
  return null
}

export const hasUserMadeChoice = () => {
  const consent = getStoredConsent()
  return consent && consent.version === CONSENT_VERSION
}

export const setConsent = (consentData) => {
  const consentObject = {
    ...consentData,
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString()
  }

  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consentObject))

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'cookie_consent_update',
        consent_necessary: consentData.necessary,
        consent_analytics: consentData.analytics,
        consent_marketing: consentData.marketing,
        consent_preferences: consentData.preferences,
        consent_timestamp: consentObject.timestamp
      })
    }
  } catch (error) {
    console.error('Error storing cookie consent:', error)
  }
}

export const acceptAllCookies = () => {
  setConsent({
    necessary: true,
    analytics: true,
    marketing: true,
    preferences: true
  })
}

export const declineAllCookies = () => {
  setConsent({
    necessary: true, // Necessary cookies are always required
    analytics: false,
    marketing: false,
    preferences: false
  })
}

export const hasConsent = (type) => {
  const consent = getStoredConsent()
  if (!consent) return false
  return consent[type] === true
}

// Initialize GTM consent mode on page load
export const initializeConsentMode = () => {
  const consent = getStoredConsent()

  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    if (consent) {
      // User has made a choice, set consent accordingly
      window.dataLayer.push({
        event: 'consent_init',
        consent_necessary: consent.necessary,
        consent_analytics: consent.analytics,
        consent_marketing: consent.marketing,
        consent_preferences: consent.preferences
      })
    } else {
      // No consent yet, default to denied for non-necessary cookies
      window.dataLayer.push({
        event: 'consent_init',
        consent_necessary: true,
        consent_analytics: false,
        consent_marketing: false,
        consent_preferences: false
      })
    }
  } else {
    console.warn('dataLayer not available during consent initialization')
  }
}
